import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config/api.config';
import '../../components/common/LoginForm.css';

/**
 * Passwort-vergessen-Seite (Befund B5, 18.08.2026)
 * Fordert per E-Mail einen Reset-Link an. Die Antwort ist bewusst generisch,
 * das Backend verrät nicht, ob die Adresse existiert.
 */
const ForgotPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Bitte geben Sie eine gültige E-Mail-Adresse ein');
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setSubmitted(true);
      } else {
        setError('Die Anfrage konnte nicht verarbeitet werden. Bitte versuchen Sie es später erneut.');
      }
    } catch {
      setError('Die Anfrage konnte nicht verarbeitet werden. Bitte versuchen Sie es später erneut.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-form-container">
      <div className="login-form-card">
        <div className="login-logo-container">
          <img src="/logo-frankenfloss.svg" alt="Frankenfloss Logo" className="login-logo" />
        </div>

        <div className="login-form-header">
          <h2>Passwort vergessen</h2>
          <p>Wir senden Ihnen einen Link zum Zurücksetzen</p>
        </div>

        {submitted ? (
          <div className="login-form">
            <p>
              Falls ein Konto mit dieser E-Mail-Adresse existiert, haben wir Ihnen soeben
              eine E-Mail mit einem Link zum Zurücksetzen des Passworts gesendet.
              Der Link ist 2 Stunden gültig. Bitte prüfen Sie auch Ihren Spam-Ordner.
            </p>
            <button type="button" className="login-button" onClick={() => navigate('/login')}>
              Zurück zur Anmeldung
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="login-form" noValidate>
            {error && (
              <div className="error-messages">
                <div className="error-message"><span>{error}</span></div>
              </div>
            )}

            <div className="form-group">
              <label htmlFor="email">E-Mail-Adresse</label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setError(null); }}
                placeholder="ihre@email.de"
                autoComplete="email"
              />
            </div>

            <button type="submit" className="login-button" disabled={isSubmitting}>
              {isSubmitting ? 'Wird gesendet...' : 'Link anfordern'}
            </button>
          </form>
        )}

        <div className="login-form-footer">
          <p>
            <button type="button" className="link-button" onClick={() => navigate('/login')}>
              Zurück zur Anmeldung
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
